/**
  * this create news article hash comment effect
**/
import $ from 'jquery';

export	function newsHashCommentUrl(){
	$('.commentLink a').on("click", function(){ 
		const url = $(this).attr('href');
		const id = $(this).attr('id');
		console.log(id);
		setCookie(id, url, 2);
	});

	function setCookie(cname, cvalue, minutes) {
		var d = new Date();
		d.setTime(d.getTime() + (minutes*60*1000));
		var expires = "expires="+ d;
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

}
